import * as s from './style'
import { useState } from 'react';

// -------------ICONS---------------
import { RiLayoutMasonryFill } from 'react-icons/ri';
import { GiPerson } from 'react-icons/gi';
import { AiFillCreditCard } from 'react-icons/ai';
import { IoIosPaper } from 'react-icons/io';
import { ImLoop2 } from 'react-icons/im';
import { GoGear } from 'react-icons/go';
import { ImExit } from 'react-icons/im';
import iconPix from './images/icon pix.png'
import iconPixColor from './images/icon pix color.png'



function Menu(){

    // PARA MUDAR O ICONE DO PIX PARA LARANJA AO SER CLICADO
    const [icon, setIcon] = useState(iconPix)



    return(
        <s.container>
            <nav>
                <ul>
                    <li className='section-actual'>
                        <button  tabIndex={2} title='dashboard'>
                            <RiLayoutMasonryFill />
                            <span> Dashboard</span>
                        </button>
                    </li>
                    <li>
                        <button  tabIndex={3} title='clientes'>
                            <GiPerson />
                            <span>Clientes</span>
                        </button>
                    </li>
                    <li onMouseEnter={() => setIcon(iconPixColor)} 
                        onMouseLeave={() => setIcon(iconPix)}
                    >
                        <button tabIndex={4} title='pix'>
                            <img  src={icon} loading='lazy' alt='Icone para botão pix' />
                            <span>Pix</span>
                        </button>
                    </li>
                    <li>
                        <button  tabIndex={5} title='cartão'>
                            <AiFillCreditCard />
                            <span>Cartão</span>
                        </button>
                    </li>
                    <li>
                        <button  tabIndex={6} title='boleto'>
                            <IoIosPaper />
                            <span>Boleto</span>
                        </button>
                    </li>
                    <li>
                        <button  tabIndex={7} title='assinatura'>
                            <ImLoop2 />
                            <span>Assinatura</span>
                        </button>
                        
                    </li>
                        
                    <li>
                        <button  tabIndex={8} title='configuração'>
                            <GoGear/>
                            <span>Configuração</span>
                        </button>
                    </li>
                        
                    <li>
                        <button  tabIndex={9} title='sair'>
                            <ImExit/>
                            <span>Sair</span>
                        </button>
                    </li>
                    
                    
                </ul>
            </nav>
        
        </s.container>
    )
}

export default Menu